'use client';

import type { AvatarProps } from '@mui/material/Avatar';

import { tss } from 'tss-react/mui';

import { Or2Image } from '@/components/image/Or2Image';
import { or2UserAvatarImageLoader } from '@/modules/image/loaders/or2ImageLoader';
import { Or2Avatar } from '@/components/Avatar/Or2Avatar';

import type { DocumentType } from '@/gql';

import type { USER_IMAGE_FRAGMENT } from '../userFragments';

export type AvatarUser = Omit<
  DocumentType<typeof USER_IMAGE_FRAGMENT>,
  '__typename'
>;

interface Props extends AvatarProps {
  size: number;
  user: AvatarUser | null | undefined;
}

const useStyles = tss.create(() => {
  return {
    image: {
      objectFit: 'cover',
    },
  };
});

export const UserAvatar = ({ size, user, sx, ...other }: Props) => {
  const { classes } = useStyles();

  if (!user)
    return <Or2Avatar {...other} sx={{ height: size, width: size, ...sx }} />;

  const { profileImage, image, firstName, lastName } = user;

  const src = profileImage || image;
  const alt = `${firstName} ${lastName}`;

  return (
    <Or2Avatar
      {...other}
      sx={{
        height: size,
        width: size,
        alignItems: 'normal',
        ...sx,
      }}
    >
      <Or2Image
        className={classes.image}
        src={src}
        alt={alt}
        size={size}
        loader={or2UserAvatarImageLoader}
      />
    </Or2Avatar>
  );
};
